export default () => {
  $('.accordion-item-title').each(function() {
    const $this = $(this),
          $button = $this.children('button'),
          $accordion = $this.parent(),
          $content = $accordion.children('.accordion-item-content');

    if ($button.length && $accordion.length && $content.length) {
      $button.attr('aria-controls', $content.attr('id'));
      $button.attr('aria-expanded', 'false');
      $content.prop('hidden', true);
      $button.click(accordionClick);
    }
  });

  function accordionClick() {
    const $this = $(this),
          $content = $('#' + $this.attr('aria-controls'));

    if ($content.length) {
      if ($this.attr('aria-expanded') === 'true') {
        $content
          .prop('hidden', true)
          .css('opacity', '');
        $this.attr('aria-expanded', 'false');
      } else {
        $content
          .prop('hidden', false)
          .css('opacity', 0);
        $this.attr('aria-expanded', 'true');

        // For sake of opacity property's transition, force browser rendering by
        // asking for element's height, before setting opacity back to normal.
        $content.height();
        $content.css('opacity', '');
      }
    }
  }
};
